// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-PlacesAutoCompleteDropdown__wrapper","content":"c-PlacesAutoCompleteDropdown__content","active":"c-PlacesAutoCompleteDropdown__active","suggestionItem":"c-PlacesAutoCompleteDropdown__suggestionItem","text":"c-PlacesAutoCompleteDropdown__text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/PlacesAutoCompleteDropdown/PlacesAutoCompleteDropdown.scss
// module id = 877
// module chunks = 0